import * as React from "react";
import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
    fill?: string;
    isActive?: boolean;
}

export const CrossIcon = ({
    fill = "#6F747B",
    isActive,
    ...restProps
}: IconProps) => (
    <svg width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
        {...restProps}>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.836817 0.835352C1.34124 0.330924 2.15908 0.330925 2.66351 0.835352L9.50016 7.67201L16.3368 0.835352C16.8412 0.330924 17.6591 0.330924 18.1635 0.835352C18.6679 1.33978 18.6679 2.15762 18.1635 2.66204L11.3269 9.4987L18.1635 16.3354C18.6679 16.8398 18.6679 17.6576 18.1635 18.162C17.6591 18.6665 16.8412 18.6665 16.3368 18.162L9.50016 11.3254L2.66351 18.162C2.15908 18.6665 1.34124 18.6665 0.836817 18.162C0.332389 17.6576 0.332389 16.8398 0.836816 16.3354L7.67347 9.4987L0.836816 2.66204C0.332389 2.15762 0.332389 1.33978 0.836817 0.835352Z" fill={fill}
            className={`dark:${isActive
                    ? "fill-primary"
                    : "fill-caption group-hover:dark:fill-primary"
                }`} />
    </svg>
);



